import React from 'react';
import { Doughnut, Bar } from 'react-chartjs-2';

const OverviewCharts = ({ sources, domains }) => {
  const safeSources = Array.isArray(sources) ? sources : [];
  const safeDomains = Array.isArray(domains) ? domains : [];
  return (
    <div className="overview-grid">
      <div className="chart-card">
        <h3>Sources</h3>
        <div className="chart-container">
          <Doughnut
            data={{
              labels: safeSources.map(s => s.source),
              datasets: [{
                data: safeSources.map(s => s.count),
                backgroundColor: ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#6b7280']
              }]
            }}
          />
        </div>
      </div>
      <div className="chart-card">
        <h3>Domains</h3>
        <div className="chart-container">
          <Bar
            data={{
              labels: safeDomains.map(d => d.domain || d.name),
              datasets: [{
                label: 'Applicants',
                data: safeDomains.map(d => d.count),
                backgroundColor: '#3b82f6'
              }]
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OverviewCharts;